<template>
    <div>
        <van-nav-bar title="莞工通讯录" class="navBar" z-index="99"    />
        <div class="login_but">
            <div class="CommonColor pb-3">欢迎使用莞工通讯录</div>
            <div class="px-3">
                <van-button type="primary" size="large" @click="login" >登 录</van-button>
            </div>
        </div>

    </div>
</template>

<script>
import {urlText} from '@/network/common'

export default {
    data(){
        return{

        }
    },
    methods:{
        login(){
       urlText()
        }
    }
}
</script>

<style>
  .navBar{
        background-color: rgb(0 145 0) ;
        color: white!important;;
    }
    .van-nav-bar__title{color: white;}
    .login_but{
        /* position: absolute; */
        margin-top: 60%;
    }
</style>
